// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catelogue-card-number {
  /* color: #ffffff; */
  color: #c0c0c0;
  /* font-size: 24px !important;
  line-height: 22px !important; */
  font-size: 18px !important;
  line-height: 19px !important;
}

.catelogue-card-subheading {
  /* color: #c0c0c0; */
  color: #ffffff;
  /* font-size: 18px !important;
  line-height: 21px !important; */
  font-size: 20px !important;
  line-height: 19px !important;
}

.catalogue-card-logo {
  width: 20px !important;
  height: 20px !important;
}

.catalogue-card-count {
  width: 24px !important;
  line-height: 22px !important;
  margin-right: auto !important;
}

.catalogue-card-owner {
  font-size: 12px !important;
  line-height: 22px !important;
  font-weight: 400;
  font-family: "Karla";
  color: #8b8b8b;
}

.catalague-card-flex-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.catalague-card-flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.catalague-card-flex-end-center {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.catalague-card-flex-align-center {
  display: flex;
  align-items: center;
  /* padding-left: 4px; */
}

.catalague-card-flexDirection-row {
  flex-direction: row;
}

.catalague-card-flexDirection-column {
  flex-direction: column;
}

.catalague-card-witdh-100 {
  width: 100% !important;
}

.catalague-card-witdh-auto {
  width: auto !important;
}

.catalague-card-witdh-50 {
  width: 50% !important;
}

.catalague-card-witdh-20 {
  width: 20% !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/catalogue/styles/catalogueCard.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,cAAc;EACd;iCAC+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd;iCAC+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".catelogue-card-number {\n  /* color: #ffffff; */\n  color: #c0c0c0;\n  /* font-size: 24px !important;\n  line-height: 22px !important; */\n  font-size: 18px !important;\n  line-height: 19px !important;\n}\n\n.catelogue-card-subheading {\n  /* color: #c0c0c0; */\n  color: #ffffff;\n  /* font-size: 18px !important;\n  line-height: 21px !important; */\n  font-size: 20px !important;\n  line-height: 19px !important;\n}\n\n.catalogue-card-logo {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.catalogue-card-count {\n  width: 24px !important;\n  line-height: 22px !important;\n  margin-right: auto !important;\n}\n\n.catalogue-card-owner {\n  font-size: 12px !important;\n  line-height: 22px !important;\n  font-weight: 400;\n  font-family: \"Karla\";\n  color: #8b8b8b;\n}\n\n.catalague-card-flex-between-center {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.catalague-card-flex-center-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.catalague-card-flex-end-center {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.catalague-card-flex-align-center {\n  display: flex;\n  align-items: center;\n  /* padding-left: 4px; */\n}\n\n.catalague-card-flexDirection-row {\n  flex-direction: row;\n}\n\n.catalague-card-flexDirection-column {\n  flex-direction: column;\n}\n\n.catalague-card-witdh-100 {\n  width: 100% !important;\n}\n\n.catalague-card-witdh-auto {\n  width: auto !important;\n}\n\n.catalague-card-witdh-50 {\n  width: 50% !important;\n}\n\n.catalague-card-witdh-20 {\n  width: 20% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
